import { call, put, takeLatest } from "redux-saga/effects";
import {
  vendorRequestEditsResponse,
  vendorApprovedResponse,
  updateCurrentActionStatus,
} from "../actions/index.js";
import {
  vendorRequestEditsOnActionRequest,
  vendorApprovedActionRequest,
} from "../services/index.js";
import { StatusEnum } from "../utilities/index.js";

export function* actionRequestRequestEdits(action) {
  yield call(vendorRequestEditsOnActionRequest, action.payload);
  yield put(updateCurrentActionStatus(StatusEnum.PROCESSING.id));
}
export function* actionRequestVendorRequestEdits() {
  yield takeLatest(
    vendorRequestEditsResponse.toString(),
    actionRequestRequestEdits
  );
}

export function* actionRequestApproved(action) {
  yield call(vendorApprovedActionRequest, action.payload);
}

export function* actionRequestVendorApproved() {
  yield takeLatest(vendorApprovedResponse.toString(), actionRequestApproved);
}
